module.exports = __webpack_public_path__ + "static/img/rs_js_4.3965ed9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rs/rs_js_4.png
// module id = 9akO
// module chunks = 1